import { Component } from "react";
// import TopNav from "../containers/TopNav/TopNav";
import { connect } from "react-redux";
// import { Translate } from "react-redux-i18n";
// import HomeHero from "../containers/HomeHero";
// import HomeFeaturedCircles from "../containers/HomeFeaturedCircles";
// import AdvantagesSection from "../containers/AdvantagesSection";
// import HowItWorksSection from "../components/HowItWorksSection";
// import NewCircleCard from "../components/NewCircleCard";
// import Footer from "../containers/Footer";
// import ReadyToCoOwnSection from "../containers/ReadyToCoOwnSection";
// import TrustpilotRating from "../components/TrustpilotRating";
// import CoBuying from "../components/CoBuying";
// import Prylpoolen from "../components/Prylpoolen";
// import Partners from "../components/Partners";

// import RequestCircle from "../containers/RequestCircle";
// import AppWrapper from "../containers/AppWrapper";
import { navigate } from "../store/navigation/operations";
import { isLoggedIn } from "../store/iam/selectors";

class Home extends Component {
  // constructor(props) {
  //   super(props);
  //   this.howItWorksRef = React.createRef();
  // }
  // navigateToHowItWorks = () => {
  //   window.scrollTo(0, this.howItWorksRef.current.offsetTop - 50);
  // };

  componentDidMount() {
    if (this.props.isLoggedIn) {
      this.props.navigate('/dashboard')
    } else {
      this.props.navigate('/login')
    }
  }

  render() {
    return null;
    // return (
    //   <AppWrapper>
    //     <TopNav />
    //     <HomeHero onHowItWorksClicked={this.navigateToHowItWorks} />
    //     <TrustpilotRating />
    //     <Prylpoolen />
    //     <CoBuying isPrypool={true} />
    //     <Partners />
    //     {/* <section> */}
    //     {/*   <div className="main-container"> */}
    //     {/*     <div className="content-wrapper align-center"> */}
    //     {/*       <h1 className="start-co-owning-header"> */}
    //     {/*         <Translate value="home.havent_found_heading" /> */}
    //     {/*       </h1> */}
    //     {/*       <h2 className="start-co-owning-subheader"> */}
    //     {/*         <Translate value="home.havent_found_subheading" /> */}
    //     {/*       </h2> */}
    //     {/*       <div className="flex-top-space-between"> */}
    //     {/*         <NewCircleCard /> */}
    //     {/*         <RequestCircle /> */}
    //     {/*       </div> */}
    //     {/*     </div> */}
    //     {/*   </div> */}
    //     {/* </section> */}
    //     {/* <HomeFeaturedCircles queryParams={this.props.queryParams} /> */}
    //     {/* <div ref={this.howItWorksRef} id="how-it-works"> */}
    //     {/*   <HowItWorksSection /> */}
    //     {/* </div> */}

    //     {/* <AdvantagesSection /> */}

    //     {/* <ReadyToCoOwnSection /> */}
    //     <Footer />
    //   </AppWrapper>
    // );
  }
}

const mapStateToProps = (state) => ({
  currentPage: state.router.location.pathname,
  queryParams: state.router.location.search.replace("?", "").split("&"),
  isLoggedIn: isLoggedIn(state),
});
const mapDispatchToProps = (dispatch) => ({
  navigate: (to) => dispatch(navigate(to)),
});
export default connect(mapStateToProps, mapDispatchToProps)(Home);
